export default {
  pages: {
    shipment: {
      title: 'Tovarlarni topshirish',
      tabs: ['Tovarlarni topshirish', 'Yuk xatlari'],
      itemsToShipment: 'Topshiralayotgan tovarlar soni',
      shipmentTime: 'Topshirish vaqti',
      waybillGeneration: 'Yuk xatini yaratish',
      items: 'tovarlar',
      addItem: "Tovar qo'shish",
      quantity: 'Soni',
      successResponse: 'Muvaffaqiyatli band qilindi',
    },
  },
};
